import { Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme: Theme) => ({
  body: {
    float: 'left',
    width: '100%',
  },
  daysBody: {
    width: '100%',
  },
  calendarContainer: {
    width: '300px',
    background: '#fff',
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  dayContainer: {
    cursor: 'pointer',
    color: theme.palette.grey[800],
    width: '14%',
    height: '1.8rem',
    display: 'block',
    position: 'relative',
    float: 'left',
    boxSizing: 'border-box',
  },

  dayContainerToday: {
    border: `solid 1px ${theme.palette.grey[400]}`,
  },
  dayContainerDisabled: {
    border: `none`,
    cursor: 'auto !important',
    pointerEvents: 'none',
    color: theme.palette.grey[400],
    background: '#fff !important',
  },
  dayContainerSelected: {
    background: theme.palette.secondary.main,
  },
  dayContainerBetweenSelection: {
    background: theme.palette.grey[300],
  },
  dayText: {
    fontSize: '12px',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dayLabels: {
    height: '30px',
    width: '100%',
  },
  name: {
    position: 'relative',
    display: 'block',
    float: 'left',
    boxSizing: 'border-box',
    width: '14%',
    height: '30px',
    lineHeight: '30px',
    color: theme.palette.grey[900],
    fontSize: '9px',
    textAlign: 'center',
  },
  timeField: {
    width: '3.5rem',
    height: 'auto !important',
  },
}));
